import { useForm } from "@kanda-libs/ks-component-ts";
import {
  type StringIndexedObject,
  useToast,
} from "@kanda-libs/ks-design-library";
import { actions, Company } from "@kanda-libs/ks-frontend-services";
import { useCallback, useState, type MouseEvent } from "react";
import { type UseFormReturn } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectors } from "store";
import { useAppDispatch } from "components/shared/App";

export interface AddReferredByFormValues {
  referredBy: string;
}

export interface AddReferredByHook {
  form: UseFormReturn<AddReferredByFormValues>;
  editing: boolean;
  onClick: (e: MouseEvent) => void;
  onSubmit: (formValues: StringIndexedObject) => void;
  isSubmitting: boolean;
}

export default function useAddReferredBy(): AddReferredByHook {
  const dispatch = useAppDispatch();
  const form = useForm<AddReferredByFormValues>();
  const isSubmitting = useSelector(selectors.company.getIsSubmitting);
  const company = useSelector(selectors.company.getEntity);

  const { showError, showSuccess } = useToast();

  const [editing, setEditing] = useState(false);

  const onClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();

      setEditing(true);
    },
    [setEditing]
  );

  const onSubmit = useCallback(
    (formValues: StringIndexedObject) => {
      const values = formValues as AddReferredByFormValues;

      dispatch(
        actions.putCompany({
          body: {
            ...company,
            referred_by: values.referredBy,
          } as Company,
          params: {
            id: company?.id!,
          },
          onError: () => {
            showError("Error updating referred by");
            setEditing(false);
          },
          onSuccess: () => {
            showSuccess("Referred by updated");
            setEditing(false);
          },
        })
      );
    },
    [setEditing]
  );

  return {
    form,
    editing,
    onClick,
    onSubmit,
    isSubmitting,
  };
}
